import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ROOT_API, API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";

function WhitelistIpAddDialog({ isOpen, onClose, refetch }) {
  const [ip, setIp] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  async function handleSubmit() {
    if (!ip.trim()) {
      toast({
        title: "IP is required",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    try {
      const res = await axiosPost(ROOT_API + API_ROUTES.IP_CREATE, {
        ip: ip.trim(),
        note: note.trim() || undefined,
      });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Create failed",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "IP added",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setIp("");
      setNote("");
      refetch?.();
      onClose();
    } catch (error) {
      toast({
        title:
          error?.response?.data?.errors?.[0]?.msg ||
          error?.response?.data?.msg ||
          "Create failed",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Whitelist IP</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isRequired>
            <FormLabel>IP address</FormLabel>
            <Input
              placeholder="e.g. 139.162.4.24"
              value={ip}
              onChange={(e) => setIp(e.target.value)}
              autoFocus
            />
          </FormControl>
          <FormControl>
            <FormLabel>Note (optional)</FormLabel>
            <Input
              placeholder="e.g. Abenla outbound IP"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose} variant="ghost">
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={loading}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default WhitelistIpAddDialog;
